import { render } from "./KeyQuestionContainer.vue?vue&type=template&id=35723c72"
import script from "./KeyQuestionContainer.vue?vue&type=script&lang=js"
export * from "./KeyQuestionContainer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__